"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSplitScreen = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const react_dom_1 = require("react-dom");
function useSplitScreen({ leftMinWidth, midPoint, rightMinWidth, }) {
    const [leftSize, setLeftSize] = react_1.useState(midPoint);
    /**
     * Dragging logic
     * The DragEnd/Drag handles are attached to document
     * The DragStart handle is attached to dragger element
     * after mousedown on the dragger, the drag is activated (dragActive.current -> true)
     * after mouseUp on the document, the drag is deactivated (dragActive.current -> false)
     */
    const dragActive = react_1.useRef(false);
    const handleDragStart = event_callback_hook_1.useEventCallback((e) => {
        dragActive.current = true;
        e.preventDefault();
    });
    const handleDragEnd = event_callback_hook_1.useEventCallback(() => {
        dragActive.current = false;
    });
    const handleDrag = event_callback_hook_1.useEventCallback((e) => {
        if (!dragActive.current) {
            return;
        }
        if (e.clientX < leftMinWidth) {
            setLeftSize(leftMinWidth);
        }
        else if (e.clientX > window.innerWidth - rightMinWidth) {
            setLeftSize(window.innerWidth - rightMinWidth);
        }
        else {
            setLeftSize(e.clientX);
        }
    });
    react_1.useEffect(() => {
        document.addEventListener('mousemove', handleDrag);
        document.addEventListener('mouseup', handleDragEnd);
        return () => {
            document.removeEventListener('mousemove', handleDrag);
            document.removeEventListener('mouseup', handleDragEnd);
        };
    }, []);
    /**
     * Logic to controll the drag position through actions
     * The transitionOn property is necessary to provide smooth width transition after button click
     */
    const [transitionOn, setTransitionOn] = react_1.useState(false);
    const handleFullSizeLeft = event_callback_hook_1.useEventCallback(() => {
        react_dom_1.unstable_batchedUpdates(() => {
            setLeftSize(window.innerWidth - rightMinWidth);
            setTransitionOn(true);
        });
        setTimeout(() => {
            setTransitionOn(false);
        }, 500);
    });
    const handleFullSizeRight = event_callback_hook_1.useEventCallback(() => {
        react_dom_1.unstable_batchedUpdates(() => {
            setLeftSize(leftMinWidth);
            setTransitionOn(true);
        });
        setTimeout(() => {
            setTransitionOn(false);
        }, 500);
    });
    const handleMoveToMiddle = event_callback_hook_1.useEventCallback(() => {
        react_dom_1.unstable_batchedUpdates(() => {
            setLeftSize(midPoint);
            setTransitionOn(true);
        });
        setTimeout(() => {
            setTransitionOn(false);
        }, 500);
    });
    const handleMoveRight = event_callback_hook_1.useEventCallback(() => {
        if (leftSize < midPoint && midPoint - leftSize > 80) {
            handleMoveToMiddle();
        }
        else {
            handleFullSizeLeft();
        }
    });
    const handleMoveLeft = event_callback_hook_1.useEventCallback(() => {
        if (leftSize > midPoint && leftSize - midPoint > 80) {
            handleMoveToMiddle();
        }
        else {
            handleFullSizeRight();
        }
    });
    const isLeftOnFullscreen = event_callback_hook_1.useEventCallback(() => {
        return leftSize === window.innerWidth - rightMinWidth;
    });
    const isRightOnFullscreen = event_callback_hook_1.useEventCallback(() => {
        return leftSize === 0;
    });
    return {
        leftSize,
        transitionOn,
        handleDragStart,
        handleFullSizeLeft,
        handleMoveToMiddle,
        handleFullSizeRight,
        handleMoveLeft,
        handleMoveRight,
        isLeftOnFullscreen,
        isRightOnFullscreen,
    };
}
exports.useSplitScreen = useSplitScreen;
//# sourceMappingURL=split-screen-hook.js.map